import * as React from 'react';

import * as styles from './ActionButtons.css';

interface IActionButtonsProps {
  buttons: React.ReactNode;
  showDailyRentButtons?: boolean;
}

export const ActionButtons: React.FC<IActionButtonsProps> = ({ buttons, showDailyRentButtons }) => {
  const actionButtonsClassName = showDailyRentButtons
    ? styles['action-buttons__daily-rent-buttons']
    : styles['action-buttons__buttons'];

  return (
    <div className={styles['action-buttons']}>
      <div className={actionButtonsClassName} data-name="ChatMessageLayout_action_buttons">
        {buttons}
      </div>
    </div>
  );
};
